import { useTranslation } from 'react-i18next';
import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import type { CategoryItem } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation('home');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: CategoryItem) => {
    setSelectedLabel(cat.name);
    setIsOpen(false);
    window.open(cat.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md mx-auto z-30">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
      >
        <span>{selectedLabel || t('hero.dropdownPlaceholder')}</span>
        <i className={`${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} w-4 h-4 flex items-center justify-center transition-transform`} />
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 right-0 bg-background-50 border border-background-200 rounded-2xl shadow-lg overflow-hidden max-h-72 overflow-y-auto z-40">
          {categories.map((cat) => (
            <button
              key={cat.key}
              onClick={() => handleSelect(cat)}
              className="w-full text-left px-5 py-3 text-sm text-foreground-800 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer border-b border-background-100 last:border-0"
            >
              {cat.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}